/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "../Button";
import { ControlTable } from "../Table";
import systemAlert from "../../utils/systemAlert";
import { clipboardCopy } from "../../utils/browser";
import useForm from "../../hooks/useForm";
import { getCompanyAddSiteInfos, deleteCompanyAddSiteInfo } from "../../apis/admin/companies";

import CareCompanyAddInfoPost from "./CareCompanyAddInfoPost"
import { forEach, isEmpty } from "lodash";

const CareCompanyAddInfo = ({
  company,
  managerCompany,
}) => {

  const [open, setOpen] = useState(false)
  const [formType, setFormType] = useState("create")
  const [post, setPost] = useState(null)

  const [list, setList] = useState([]);
  const [fields, setFields] = useState([]);

  const onChangePassword = (data) => {
    if (isEmpty(data)) {
      return
    }
    const tempList = list.map((item) => {
      if(item.idx === data.idx) {
        item.isHidePassword = !item.isHidePassword
        return item
      } else {
        return item
      }
    })

    setList(tempList)
  }

  useEffect(() => {
    setFields([
    { title: "타이틀", key: "title" },
    { 
      title: "URL", 
      key: "url",
      onValue: (val, fields, data) => {
          return <div onClick={()=>{window.open(val, "_blank")}} style={{ cursor: "pointer" }}>{val}</div>
      },
    },
    { 
      title: "아이디", 
      key: "id",
      onValue: (val, fields, data) => {
        return <div onClick={()=>{clipboardCopy(val, '아이디 복사되었습니다.')}} style={{ cursor: "pointer" }}>{val}</div>
      },
    },
    { 
      title: "비밀번호", 
      key: "pwd",
      onValue: (val, fields, data) => {
        let pwdValue = ""
        forEach(val, item => {
          pwdValue += "*"
        })
        
        if (isEmpty(val)) return (<></>)

        return (
          <>
            <div>
              <span onClick={()=>{clipboardCopy(val, '비밀번호 복사되었습니다.')}} style={{ cursor: "pointer" }}>{data.isHidePassword ? pwdValue : val}</span>
              <span>{" "}{" "}</span>
              <span className="icon" style={{ cursor: "pointer" }}>
                <i
                  className={`mdi ${data.isHidePassword ? "mdi-eye" : "mdi-eye-off" } font-size-24`}
                  onClick={() => onChangePassword(data)}
                />
              </span>
            </div>
          </>
        )
      },
    },
    {
      title: '작성일',
      key: 'createdTime',
      type: 'date'
    }
  ]);
  }, [list]);

  const _getData = () => {
    setIsLoading(true);
    setList([]);
    getCompanyAddSiteInfos(managerCompany.companyIdx, company.companyIdx)
      .then((res) => {
        const datas = res.data
        forEach(datas, item => {
          item.isHidePassword = true
        })
        setList(datas);
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const {
    setSubmit,
    handleSubmit,
    // LIST 용
    isLoading, setIsLoading,
  } = useForm()

  useEffect(() => {
    if (company)
    {
      _getData()
      setSubmit(_getData)
    }
  }, [company])

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setPost(data)
          setFormType("modify")
          setOpen(true)
        },
      },
      {
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert('해당 내역을 삭제 하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  setIsLoading(true);
                  deleteCompanyAddSiteInfo(managerCompany.companyIdx, company.companyIdx, data.idx)
                    .then(() => {
                      setIsLoading(false)
                      handleSubmit()
                    })
                    .catch((err) => { });
                }
              }
            ]
          })
        },
      },
    ],
  };

  return (
    <div className="care-company-addsiteinfo">
      <div className="header-wrap pb-12">
        <ul className="header-tab">
            <li className="header-item" > {"사이트 정보 관리"} </li>
        </ul>
        <div className="button-wrap">
          <Button
            style={{ lineHeight: '16px' }}
            onClick={() => { 
                setPost(null)
                setFormType("create"); 
                setOpen(true);
              }
            }
          >등록</Button>
        </div>
      </div>

      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        isControl={false}
        rowBtn={rowBtnConfig}
        //onSelect={onRowClick}
      />
      <CareCompanyAddInfoPost
        post={post}
        open={open} 
        setOpen={setOpen}
        submit={handleSubmit}
        orgMode={formType}
        company={company}
        managerCompany={managerCompany}
      />
    </div>
  );
};

export default CareCompanyAddInfo;
